import React, { useState, useEffect } from 'react';
import '../../styles/AdminDashboard.scss';
import { cmsAPI } from '../../utils/api';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaGithub, FaYoutube } from 'react-icons/fa';

const AdminSocial = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ id: null, platform: '', url: '', icon: 'FaFacebook' });
  const [isEditing, setIsEditing] = useState(false);

  const icons = {
    FaFacebook: <FaFacebook />,
    FaTwitter: <FaTwitter />,
    FaLinkedin: <FaLinkedin />,
    FaInstagram: <FaInstagram />,
    FaGithub: <FaGithub />,
    FaYoutube: <FaYoutube />,
  };

  const fetchLinks = async () => {
    try {
      const res = await cmsAPI.getSocialLinks();
      if (res.data.success) setLinks(res.data.data);
    } catch (error) {
      console.error('Error fetching links:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('platform', formData.platform);
    data.append('url', formData.url);
    data.append('icon', formData.icon);

    try {
      let res;
      if (isEditing) {
        res = await cmsAPI.updateSocialLink(formData.id, data);
      } else {
        res = await cmsAPI.createSocialLink(data);
      }

      if (res.data.success) {
        fetchLinks();
        resetForm();
      }
    } catch (error) {
      console.error('Error saving link:', error);
      alert('Failed to save social link');
    }
  };

  const resetForm = () => {
    setFormData({ id: null, platform: '', url: '', icon: 'FaFacebook' });
    setIsEditing(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this social link?")) return;
    try {
      const res = await cmsAPI.deleteSocialLink(id);
      if (res.data.success) {
        fetchLinks();
      }
    } catch (error) {
      console.error('Error deleting link:', error);
      alert('Failed to delete link');
    }
  };

  const handleEdit = (link) => {
    setFormData({ 
      id: link.id, 
      platform: link.platform, 
      url: link.url, 
      icon: link.icon || 'FaFacebook' 
    });
    setIsEditing(true);
  };

  return (
    <div className="admin-dashboard-page">
      <div className="dashboard-header">
        <h1>CMS - Social Links</h1>
        <p>Manage your social media presence</p>
      </div>

      <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
        <h3>{isEditing ? 'Edit Social Link' : 'Add New Social Link'}</h3>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <input 
              type="text" placeholder="Platform Name (e.g. Facebook)" required
              value={formData.platform} onChange={(e) => setFormData({...formData, platform: e.target.value})}
              style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <select 
              value={formData.icon} onChange={(e) => setFormData({...formData, icon: e.target.value})}
              style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              {Object.keys(icons).map(icon => (
                <option key={icon} value={icon}>{icon}</option>
              ))}
            </select>
          </div>
          <input 
            type="url" placeholder="Profile URL (e.g. https://facebook.com/yourpage)" required
            value={formData.url} onChange={(e) => setFormData({...formData, url: e.target.value})}
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" style={{ padding: '10px 20px', background: '#00526A', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
              {isEditing ? 'Update Link' : 'Add Link'}
            </button>
            {isEditing && (
              <button type="button" onClick={resetForm} style={{ padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
            )}
          </div>
        </form>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px' }}>
        {loading ? <p>Loading links...</p> : links.length > 0 ? links.map(link => (
          <div key={link.id} style={{ background: '#fff', borderRadius: '8px', padding: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{ fontSize: '24px', color: '#00526A' }}>
              {icons[link.icon] || <FaFacebook />}
            </div>
            <div style={{ flex: 1 }}>
              <h4 style={{ margin: '0 0 5px 0' }}>{link.platform}</h4>
              <p style={{ margin: 0, fontSize: '0.8em', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '150px' }}>{link.url}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <button onClick={() => handleEdit(link)} style={{ padding: '2px 8px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8em' }}>Edit</button>
              <button onClick={() => handleDelete(link.id)} style={{ padding: '2px 8px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8em' }}>Delete</button>
            </div>
          </div>
        )) : (
          <p>No social links added yet.</p>
        )}
      </div>
    </div>
  );
};

export default AdminSocial;
